import {
  BiddingSummaryCapagInfo,
  BiddingSummaryEditalDownload,
} from 'store/modules/bidding_summary_store/types';

export enum BiddingChatTypes {
  OPEN_CHAT = '@bidding_chat/OPEN_CHAT',
  CLOSE_CHAT = '@bidding_chat/CLOSE_CHAT',
  CLEAR_CURRENT_CHAT = '@bidding_chat/CLEAR_CURRENT_CHAT',
  FETCH_CHAT_REQUEST = '@bidding_chat/FETCH_CHAT_REQUEST',
  FETCH_CHAT_SUCCESS = '@bidding_chat/FETCH_CHAT_SUCCESS',
  FETCH_CHAT_FAILURE = '@bidding_chat/FETCH_CHAT_FAILURE',
  FETCH_CHAT_MESSAGES_REQUEST = '@bidding_chat/FETCH_CHAT_MESSAGES_REQUEST',
  FETCH_CHAT_MESSAGES_SUCCESS = '@bidding_chat/FETCH_CHAT_MESSAGES_SUCCESS',
  FETCH_CHAT_MESSAGES_FAILURE = '@bidding_chat/FETCH_CHAT_MESSAGES_FAILURE',
  CREATE_CHAT_MESSAGE_REQUEST = '@bidding_chat/CREATE_CHAT_MESSAGE_REQUEST',
  CREATE_CHAT_MESSAGE_SUCCESS = '@bidding_chat/CREATE_CHAT_MESSAGE_SUCCESS',
  CREATE_CHAT_MESSAGE_FAILURE = '@bidding_chat/CREATE_CHAT_MESSAGE_FAILURE',
  UPDATE_CHAT_MESSAGE_REQUEST = '@bidding_chat/UPDATE_CHAT_MESSAGE_REQUEST',
  UPDATE_CHAT_MESSAGE_SUCCESS = '@bidding_chat/UPDATE_CHAT_MESSAGE_SUCCESS',
  UPDATE_CHAT_MESSAGE_FAILURE = '@bidding_chat/UPDATE_CHAT_MESSAGE_FAILURE',
  FETCH_USER_QUESTION_REQUEST = '@bidding_chat/FETCH_USER_QUESTION_REQUEST',
  FETCH_USER_QUESTION_SUCCESS = '@bidding_chat/FETCH_USER_QUESTION_SUCCESS',
  FETCH_USER_QUESTION_FAILURE = '@bidding_chat/FETCH_USER_QUESTION_FAILURE',
  CREATE_USER_QUESTION_REQUEST = '@bidding_chat/CREATE_USER_QUESTION_REQUEST',
  CREATE_USER_QUESTION_SUCCESS = '@bidding_chat/CREATE_USER_QUESTION_SUCCESS',
  CREATE_USER_QUESTION_FAILURE = '@bidding_chat/CREATE_USER_QUESTION_FAILURE',
  UPDATE_USER_QUESTION_REQUEST = '@bidding_chat/UPDATE_USER_QUESTION_REQUEST',
  UPDATE_USER_QUESTION_SUCCESS = '@bidding_chat/UPDATE_USER_QUESTION_SUCCESS',
  UPDATE_USER_QUESTION_FAILURE = '@bidding_chat/UPDATE_USER_QUESTION_FAILURE',
  DELETE_USER_QUESTION_REQUEST = '@bidding_chat/DELETE_USER_QUESTION_REQUEST',
  DELETE_USER_QUESTION_SUCCESS = '@bidding_chat/DELETE_USER_QUESTION_SUCCESS',
  DELETE_USER_QUESTION_FAILURE = '@bidding_chat/DELETE_USER_QUESTION_FAILURE',
}

export interface BiddingChatTabState {
  modalOpened: boolean;
  currentBiddingId: number;
  currentChatId: null | number;
  editalDownload?: BiddingSummaryEditalDownload;
  capagInfo?: BiddingSummaryCapagInfo;
}
export interface BiddingChatStates {
  [key: string]: BiddingChatTabState;
}

export interface BiddingChatMessageTypes {
  id: number | null;
  bidding_user_chat_id: number | null;
  role: 'user' | 'assistant';
  content: string;
  rating: null | number;
  created_at: string;
  updated_at: string;
}

export interface BiddingChatChatContentTypes {
  user_chat_messages: Array<BiddingChatMessageTypes>;
}
export interface BiddingChatDataTypes {
  current_chat: BiddingChatStates;
  user_chats: {
    [key: string]: BiddingChatChatContentTypes;
  };
}

export interface BiddingChatUserSavedQuestionContentTypes {
  id: number;
  content: string;
  created_at: string;
  updated_at: string;
}

export interface BiddingChatUserSavedQuestionsTypes {
  questions: Array<BiddingChatUserSavedQuestionContentTypes>;
}

export interface DefaultRequestTypes {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface RequestState {
  fetch_chat: { [key: string]: DefaultRequestTypes };
  fetch_chat_messages: { [key: string]: DefaultRequestTypes };
  create_chat_message: { [key: string]: DefaultRequestTypes };
  update_chat_message: { [key: string]: DefaultRequestTypes };
  fetch_user_question: { [key: string]: DefaultRequestTypes };
  create_user_question: { [key: string]: DefaultRequestTypes };
  update_user_question: { [key: string]: DefaultRequestTypes };
  delete_user_question: { [key: string]: DefaultRequestTypes };
}

export interface BiddingChatState {
  readonly bidding_chat: BiddingChatDataTypes;
  readonly user_saved: BiddingChatUserSavedQuestionsTypes;
  readonly request: RequestState;
}
